module.exports = __webpack_public_path__ + "img/dsci0155.08b9c25b.jpg";